import Vue from 'vue';
import ActionButton from '@/components/action_button/Index.vue';
import { DIY } from '@/helpers/constants/Store';
import { createNamespacedHelpers } from 'vuex';
import '@/assets/stylesheets/v2/_success-launch.scss';
import ActiveFacebookPage from '@/plugins/graphql/queries/active-facebook-page.gql';
const { mapGetters, mapMutations } = createNamespacedHelpers(DIY);
export default Vue.extend({
    apollo: {
        activePage: {
            query: ActiveFacebookPage,
            variables() {
                return {
                    appUUID: this.appUuid,
                };
            },
            update(data) {
                return data.activePage;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        store: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            activePage: null,
        };
    },
    computed: {
        ...mapGetters(['toggle']),
        imageUrl() {
            return require('@/assets/images/success-launch.svg');
        },
        dashboardUrl() {
            return `/apps/${this.$route.params.key}/${this.appUuid}/overview`;
        },
        messengerLink() {
            if (this.$data.activePage) {
                return `https://m.me/${this.$data.activePage.fbPageId}`;
            }
            return '';
        },
    },
    methods: {
        ...mapMutations(['hide']),
        goToDashboard() {
            this.$router.push(this.dashboardUrl);
            const self = this;
            self.hide();
        },
        visitPage() {
            window.open(this.messengerLink, '_blank');
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-dialog', {
            props: {
                persistent: true,
                value: self.toggle,
                contentClass: 'success-launch',
            },
        }, [
            createElement('v-card', { class: 'card pa-4' }, [
                createElement('v-layout', { class: 'column align-center justify-center fill-height' }, [
                    createElement('v-flex', { class: 'shrink text-xs-right', style: 'width: 100%; ' }, [
                        createElement('v-btn', {
                            props: {
                                flat: true,
                                icon: true,
                                color: 'grey',
                            },
                            on: {
                                click: () => {
                                    self.hide();
                                },
                            },
                            class: '',
                        }, [createElement('v-icon', {}, ['close'])]),
                    ]),
                    createElement('v-flex', { class: 'my-4' }, [
                        createElement('v-img', {
                            props: {
                                src: this.imageUrl,
                                height: '149px',
                                width: '260px',
                            },
                            attrs: {
                                id: 'icon',
                            },
                        }),
                    ]),
                    createElement('v-flex', [
                        createElement('p', { class: 'header', attrs: { id: 'header' } }, [
                            'Congratulations!',
                        ]),
                    ]),
                    createElement('v-flex', [
                        createElement('p', { class: 'content', attrs: { id: 'greeting' } }, [
                            'Welcome to the ChatGenie community!',
                        ]),
                        createElement('p', { class: { content: true, 'd-none': this.store }, attrs: { id: 'subheader' } }, ['You now have access to everything you need to customize your In-App Store']),
                        createElement('p', { class: { content: true, 'd-none': this.store }, attrs: { id: 'caption' } }, ['Start Exploring your In-App Store, please click the button below']),
                    ]),
                    createElement('v-flex', { class: { shrink: true, 'd-none': this.store }, attrs: { id: 'button' } }, [
                        createElement(ActionButton, {
                            props: {
                                blueTheme: true,
                                common: true,
                                disable: !self.activePage,
                            },
                            on: {
                                wasClicked: self.visitPage,
                            },
                        }, ['Go to In-App Store']),
                    ]),
                ]),
            ]),
        ]);
    },
});
